import React, { useEffect } from "react";
import useDynamicColors from "../../../hooks/useDynamicColors";
import "./style.css";

export const BackofficeBackground = () => {
  const colors = useDynamicColors();

  // Reset body transform for full screen background
  useEffect(() => {
    document.body.style.transform = 'none';
    document.body.style.width = '100%';
    document.body.style.height = '100%';

    return () => {
      document.body.style.transform = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, []);

  // Create lighter/darker variants of primary color
  const primaryColor = colors.primario;

  return (
    <div className="backoffice-background">
      <svg
        className="gradient-svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Main gradient - diagonal from primary to white */}
          <linearGradient id="mainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={primaryColor} />
            <stop offset="40%" stopColor={primaryColor} stopOpacity="0.6" />
            <stop offset="70%" stopColor={primaryColor} stopOpacity="0.2" />
            <stop offset="100%" stopColor="#ffffff" />
          </linearGradient>

          {/* Subtle overlay gradient */}
          <linearGradient id="overlayGradient" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.3" />
            <stop offset="50%" stopColor="#ffffff" stopOpacity="0" />
            <stop offset="100%" stopColor={primaryColor} stopOpacity="0.1" />
          </linearGradient>

          {/* Bottom wave gradient */}
          <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={primaryColor} stopOpacity="0.15" />
            <stop offset="100%" stopColor={primaryColor} stopOpacity="0.4" />
          </linearGradient>
        </defs>

        {/* Base gradient */}
        <rect width="100" height="100" fill="url(#mainGradient)" />

        {/* Overlay for depth */}
        <rect width="100" height="100" fill="url(#overlayGradient)" />

        {/* Geometric shapes for visual interest */}
        <circle cx="85" cy="15" r="25" fill={primaryColor} opacity="0.08" />
        <circle cx="10" cy="90" r="20" fill={primaryColor} opacity="0.1" />

        {/* Subtle bottom wave */}
        <path
          d="M0,85 Q25,75 50,80 T100,78 L100,100 L0,100 Z"
          fill="url(#waveGradient)"
        />
        <path
          d="M0,90 Q30,82 60,88 T100,85 L100,100 L0,100 Z"
          fill={primaryColor}
          opacity="0.12"
        />
      </svg>
    </div>
  );
};
